module.exports = __webpack_public_path__ + "static/media/tourist_arrival_ph_map_regional_wide_domfor.2ca5ddba.png";